"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "m16 11.9999-13.0712-.9336A1 1 0 0 1 2 10.0688V5.4276c0-.694.6896-1.177 1.3417-.9398l18.0739 6.5723c.8776.3192.8776 1.5605 0 1.8796L3.3417 19.512C2.6896 19.7492 2 19.2662 2 18.5722V13.931a1 1 0 0 1 .9287-.9974L16 11.9999Z", clipRule: "evenodd" })), 'SendSolidIcon');
